<template>
    <box-content-message>
        <template v-slot:icon>
            <img src="@/assets/gifs/error.gif"
                 alt="error"
                 width="90"
                 height="90"
            >
        </template>
        <template v-slot:primaryText>
            <div class="primaryText" v-if="errorType === 'userExists'">You already have <br/> an account</div>
            <div v-else>We're sorry</div>
        </template>
        <template v-slot:secondaryText>
            <div v-if="errorType === 'systemError'" class="systemErrorMessage">There was a problem in the email
                <br/>confirmation process
            </div>
            <div v-else-if="errorType === 'tokenExpired'">Confirmation link has expired</div>
        </template>
        <template v-slot:secondaryTextAdditional>
            <button class="ssa-button primary headlineSmall"
                    @click="routeTo()">
                {{ errorType === 'userExists' ? 'Log in' : 'Sign up' }}
            </button>
        </template>
    </box-content-message>
</template>

<script>
import BoxContentMessage from '@/pages/entrance/components/BoxContentMessageLayout.vue';

export default {
    name: 'verifyingFlowErrorMessage',
    props: {
        errorType: {
            type: String,
            default: 'systemError'
        }
    },
    components: {
        BoxContentMessage
    },
    data() {
        return {};
    },
    methods: {
        routeTo() {
            this.$router.push({ path: this.errorType === 'userExists' ? '/login' : '/signup' });
        }
    }
};
</script>
<style scoped lang="scss">
@import "~styles/buttons.V2";

.systemErrorMessage {
    line-height: 1.57;
}
.primaryText {
    line-height: normal;
}

button.headlineSmall {
    width: 141px;
}
</style>
